(function () {
  'use strict';

  /**
   * pp-product-variants — hover preview de la imagen principal.
   *
   * Al pasar el cursor sobre una variante (swatch o chip), la
   * imagen principal del gallery cambia temporalmente a la imagen
   * destacada de esa variante. Mouseout restaura.
   *
   * El src se guarda en el dataset del item ANTES de cambiar, en
   * lugar de en una variable global. Así si el usuario clickea un
   * thumb (pp-main-product.js) y luego hace hover en una variante,
   * al mouseout se restaura al thumb activo — no al src inicial.
   *
   * Los items con clase `.is-active` (producto actual) no disparan
   * el swap: ya están en su propia imagen.
   *
   * El texto del label (`data-pp-variants-current`) también se
   * actualiza al hover para dar preview del nombre de la variante.
   */

  function initBlock(root) {
    var items = root.querySelectorAll('[data-pp-variants-image]');
    var currentEl = root.querySelector('[data-pp-variants-current]');
    var defaultDisplay = currentEl ? (currentEl.getAttribute('data-pp-variants-default') || '') : '';

    // Actualiza el label "actual". Si es una medida (.pp-measure), mantiene
    // data-cm sincronizado y convierte a la unidad activa; pp-units re-pinta
    // este mismo nodo al cambiar de unidad. Si no, asigna el texto tal cual.
    function setCurrent(text) {
      if (!currentEl) return;
      if (window.ppUnits && currentEl.classList.contains('pp-measure')) {
        currentEl.setAttribute('data-cm', text);
        currentEl.textContent = window.ppUnits.convert(text);
      } else {
        currentEl.textContent = text;
      }
    }

    var mainImage = document.querySelector('[data-pp-main-image] img');
    if (!mainImage || items.length === 0) return;

    items.forEach(function (item) {
      var previewSrc = item.getAttribute('data-pp-variants-image');
      var displayText = item.getAttribute('data-pp-variants-display');

      item.addEventListener('mouseenter', function () {
        if (displayText) {
          setCurrent(displayText);
        }
        if (!previewSrc || item.classList.contains('is-active')) return;
        item.dataset.ppSavedSrc = mainImage.src;
        item.dataset.ppSavedSrcset = mainImage.getAttribute('srcset') || '';
        mainImage.removeAttribute('srcset');
        mainImage.src = previewSrc;
      });

      item.addEventListener('mouseleave', function () {
        setCurrent(defaultDisplay);
        if (item.classList.contains('is-active')) return;
        if (item.dataset.ppSavedSrc) {
          mainImage.src = item.dataset.ppSavedSrc;
          if (item.dataset.ppSavedSrcset) {
            mainImage.setAttribute('srcset', item.dataset.ppSavedSrcset);
          }
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-pp-variants]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
